const messages = {
  fr: {
    message: {
      suggest: 'Suggérer une modification',
      searchlocation: 'Chercher un emplacement',
      visitWeb: 'Visitez notre site',
      presentation: `Bienvenue sur la carte alimentaire de Montréal. Les icônes mises en évidence sur la carte sont les services communautaires qui visent à fournir aux individus et à la collectivité des aliments plus sains, équitables et durables. Un zoom permet également d'afficher les commerces où l'on peut acheter ou consommer des aliments. Appuyez sur l'un ou l'autre des numéros pour vous rendre à l'échelle de l'arrondissement. Lorsque vous cliquez sur une icône, vous avez le choix d'émettre une suggestion sur l'information qui y est affichée. Vous pouvez également utiliser la légende pour filtrer les types de données que vous souhaitez voir ou cacher, en sélectionnant l'icône.`
    }
  },
  en: {
    message: {
      suggest: 'Suggest a change',
      searchlocation: 'Search for a location',
      visitWeb: 'Visit our site',
      presentation: `Welcome to the Montreal Food Map. The default icons highlighted on the map are food assets, which aim to provide individuals with healthier, sustainable food options and help. Zooming in closer will also bring up commercial points of interest where food can be purchased or consumed. Press on any of the numbers to begin to be brought to that specific borough. You may also use the legend to filter out the types of data you would like to see or eliminate by selecting the icon.`
    }
  }
}
export default messages
